// btw-front/src/router/index.js
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "../pages/Home";
import Partners from "../pages/Partners";
import PartnerSignup from "../pages/PartnerSignup";
import PartnerPending from "../pages/PartnerPending";
import PartnerDashboard from "../pages/PartnerDashboard";
import PartnerPerformance from "../pages/PartnerPerformance";
import PartnerDealNew from "../pages/PartnerDealNew";
import PartnerDealDetail from "../pages/PartnerDealDetail";
import PartnerDealSearch from "../pages/PartnerDealSearch";
import PartnerEdit from "../pages/PartnerEdit";
import PartnerProfile from "../pages/PartnerProfile";
import PartnerNotices from "../pages/PartnerNotices";
import PartnerNoticeDetail from "../pages/PartnerNoticeDetail";
import AdminDashboard from "../pages/AdminDashboard";
import AdminDealNew from "../pages/AdminDealNew";
import AdminDealEdit from "../pages/AdminDealEdit";
import AdminNoticeNew from "../pages/AdminNoticeNew";
import AdminNoticeEdit from "../pages/AdminNoticeEdit";
import AdminSalesReps from "../pages/AdminSalesReps";
import PasswordReset from "../pages/PasswordReset";
import ProtectedRoute from "../components/auth/ProtectedRoute";
import OwnershipGuard from "../components/auth/OwnershipGuard";

export default function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />

      {/* 공개 — 관리자 진입 시 /admin 흡수 */}
      <Route
        path="/partners"
        element={
          <ProtectedRoute allow={["guest", "pending", "partner"]} adminRedirect>
            <Partners />
          </ProtectedRoute>
        }
      />
      <Route
        path="/partners/signup"
        element={
          <ProtectedRoute allow={["guest"]} adminRedirect>
            <PartnerSignup />
          </ProtectedRoute>
        }
      />
      <Route
        path="/partners/pending"
        element={
          <ProtectedRoute allow={["pending"]} allowSignupToken adminRedirect>
            <PartnerPending />
          </ProtectedRoute>
        }
      />
      <Route
        path="/partners/dashboard"
        element={
          <ProtectedRoute allow={["partner"]} adminRedirect>
            <PartnerDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/partners/performance"
        element={
          <ProtectedRoute allow={["partner", "admin"]}>
            <PartnerPerformance />
          </ProtectedRoute>
        }
      />
      <Route
        path="/partners/edit"
        element={
          <ProtectedRoute allow={["partner"]} adminRedirect>
            <PartnerEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path="/partners/profile"
        element={
          <ProtectedRoute allow={["partner"]} adminRedirect>
            <PartnerProfile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/partners/deals/new"
        element={
          <ProtectedRoute allow={["partner"]} adminRedirect>
            <PartnerDealNew />
          </ProtectedRoute>
        }
      />
      <Route
        path="/partners/deals/search"
        element={
          <ProtectedRoute allow={["partner"]} adminRedirect>
            <PartnerDealSearch />
          </ProtectedRoute>
        }
      />
      <Route
        path="/partners/deals/:id"
        element={
          <ProtectedRoute allow={["partner", "admin"]}>
            <OwnershipGuard>
              <PartnerDealDetail />
            </OwnershipGuard>
          </ProtectedRoute>
        }
      />
      {/* 공지사항 — 파트너 읽기 전용(관리자도 열람 가능) */}
      <Route
        path="/partners/notices"
        element={
          <ProtectedRoute allow={["partner", "admin"]}>
            <PartnerNotices />
          </ProtectedRoute>
        }
      />
      <Route
        path="/partners/notices/:id"
        element={
          <ProtectedRoute allow={["partner", "admin"]}>
            <PartnerNoticeDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <ProtectedRoute allow={["admin"]}>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/notices/new"
        element={
          <ProtectedRoute allow={["admin"]}>
            <AdminNoticeNew />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/notices/:id/edit"
        element={
          <ProtectedRoute allow={["admin"]}>
            <AdminNoticeEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/deals/new"
        element={
          <ProtectedRoute allow={["admin"]}>
            <AdminDealNew />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/deals/:id/edit"
        element={
          <ProtectedRoute allow={["admin"]}>
            <AdminDealEdit />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/sales-reps"
        element={
          <ProtectedRoute allow={["admin"]}>
            <AdminSalesReps />
          </ProtectedRoute>
        }
      />

      {/* 비밀번호 재설정 — 토큰 없으면 이메일 입력, 있으면 새 비밀번호 입력. 로그인 무관 접근 */}
      <Route path="/password-reset" element={<PasswordReset />} />

      {/* Future: <Route path="/work" element={<Work />} /> */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
